export class SmsFormDto {
  phoneNumber = "";
}